export const TRADER_AVATAR_ICON_TEST_ID = "trader-avatar-icon";
